import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { Movement } from './../../../../models/loyalty-movement.model';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'app/services/user/auth.service';
import { HttpClient } from '@angular/common/http';
import { CustomersService } from 'app/services/customer/customers.service';
import * as FileSaver from 'file-saver';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { error } from 'console';

@Component({
  selector: 'app-loyalty-account-balance-table',
  templateUrl: './loyalty-account-balance-table.component.html',
  styleUrls: ['./loyalty-account-balance-table.component.css']
})
export class LoyaltyAccountBalanceTableComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  noFilter = KontableComponent.NoFilter;
  dateFilter = KontableComponent.DateFilter;
   textFilter = KontableComponent.TextFilter;
  @Input() movements: Movement[];
  @Input() customerIdforExport;
  @Input() movementExportExcelPermission;

  constructor(  private httpClient: HttpClient,
    private loyaltyAcmService: LoyaltyAcmService) { }



  //TODO: secondo me sarebbe da fare una chiamata per trovare le carte disponibili a cliente
  //utilizare una dropdown come options le carte ritornate dalla chiamata
  ngOnInit() {
  }


  downloadExcel(filters) {

    let isValid = true;
  
    // Controllo se `customerIdforExport` esiste ed è valido
    if (!this.customerIdforExport) {
      console.error('Errore: customerIdforExport non è valido o non è definito.');
      isValid = false;
    }
  
    if (isValid) {
      this.loyaltyAcmService.getExcelFilename(this.customerIdforExport, filters).subscribe(
        response => {
          // Verifica se la risposta contiene rsp_data in modo sicuro
          const filename = response && response.rsp_data ? response.rsp_data : null;
      
          if (filename) {
            this.loyaltyAcmService.downloadExcel(filename).subscribe(
              res => FileSaver.saveAs(res, filename),
              error => console.error('Errore durante il download:', error)
            );
          } else {
            console.log('Errore nella chiamata di export: rsp_data non presente');
          }
        },
        error => console.error('Errore nella richiesta del filename:', error)
      );
      
      
    }
  }
  convertXactTime(xactTime: string | null): string {
    if (!xactTime) return '';
  
    // Esempio input: "15:19:14.511" o "00:00:00"
    const timeParts = xactTime.split(':'); // ["15", "19", "14.511"]
    if (timeParts.length < 3) return '';
  
    const hours = timeParts[0];
    const minutes = timeParts[1];
    const seconds = timeParts[2].split('.')[0]; // "14" from "14.511"
  
    return `${hours}:${minutes}.${seconds}`;
  }
  
  

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-account-balance/loyalty-account-balance-table/loyalty-account-balance-table.component.ts